var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"title":"Editar plantilla"}},[_c('formulario',{attrs:{"plantilla-contrato":_vm.plantillaContrato,"unidades-negocio-id":_vm.unidadesNegocioId,"opciones-unidades-negocio":_vm.opcionesUnidadesNegocio},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }